export const TRANSFAREDFOLDERS = "/api/requests-transfer/all-folders?status=1"
export const TRANSFAREDFOLDERS_STATUS = "/api/requests-transfer/change-status/:param"
export const TRANSFAREDFOLDER = "/customers/:param"
export const TRANSFAREDFOLDERBYID = "/api/transfered-foldersD2c/:param"


export const SOCIAL_FENANCIAL_SITUATION = "/api/"
